export default __webpack_public_path__ + "static/media/zine-avatar11.66ad58e9.png";